import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

const ImageViewModal = ({
  show,
  onHide,
  imageData,
  title = 'Visualizar Imagem',
  size = 'lg',
}) => {
  const handleClose = () => {
    // Limpa URL blob se existir para evitar vazamento de memória
    if (imageData?.imageUrl && imageData.imageUrl.startsWith('blob:')) {
      URL.revokeObjectURL(imageData.imageUrl);
    }
    onHide();
  };

  const getImageUrl = () => {
    if (imageData?.imageUrl) {
      return imageData.imageUrl;
    }
    if (imageData?.src) {
      return imageData.src;
    }
    if (imageData?.url) {
      return imageData.url;
    }
    return null;
  };

  const getImageTitle = () => {
    if (imageData?.orientacao) {
      return `${title} - ${
        imageData.orientacao === 'P' ? 'PAISAGEM' : 'RETRATO'
      }`;
    }
    if (imageData?.title) {
      return `${title} - ${imageData.title}`;
    }
    return title;
  };

  const getImageAlt = () => {
    if (imageData?.orientacao) {
      return `Imagem ${imageData.orientacao === 'P' ? 'Paisagem' : 'Retrato'}`;
    }
    if (imageData?.alt) {
      return imageData.alt;
    }
    return 'Imagem';
  };

  const fallbackImage =
    'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI2Y4ZjlmYSIvPjx0ZXh0IHg9IjEwMCIgeT0iMTAwIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTQiIGZpbGw9IiM2Yzc1N2QiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj5JbWFnZW0gbsOjbyBlbmNvbnRyYWRhPC90ZXh0Pjwvc3ZnPg==';

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size={size}
      centered
      backdrop="static"
    >
      <Modal.Header
        closeButton
        style={{ padding: '0.75rem 1rem', minHeight: 'auto' }}
      >
        <Modal.Title style={{ fontSize: '1.1rem', margin: 0 }}>
          <i className="bi bi-image me-2"></i>
          {getImageTitle()}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center">
        {imageData && getImageUrl() ? (
          <img
            src={getImageUrl()}
            alt={getImageAlt()}
            style={{
              maxWidth: '100%',
              maxHeight: '70vh',
              objectFit: 'contain',
            }}
            className="rounded shadow"
            onError={e => {
              e.target.src = fallbackImage;
            }}
          />
        ) : imageData?.loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: '200px' }}
          >
            <div className="text-center">
              <div className="spinner-border text-primary mb-3" role="status">
                <span className="visually-hidden">Carregando imagem...</span>
              </div>
              <p className="text-muted">Carregando imagem...</p>
            </div>
          </div>
        ) : (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: '200px' }}
          >
            <div className="text-center text-muted">
              <i className="bi bi-image fs-1 mb-3"></i>
              <p>Nenhuma imagem disponível</p>
            </div>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={handleClose}>
          <i className="bi bi-x-lg me-1"></i>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

ImageViewModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  imageData: PropTypes.shape({
    imageUrl: PropTypes.string,
    src: PropTypes.string,
    url: PropTypes.string,
    orientacao: PropTypes.string,
    title: PropTypes.string,
    alt: PropTypes.string,
    loading: PropTypes.bool,
  }),
  title: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'lg', 'xl']),
};

export default ImageViewModal;
